import $ from 'wee-dom';
import $events from 'wee-events';
import { RouteHandler } from 'wee-routes';

function showFacebookLinks() {
	$('.js-facebook-submenu')
		.toggleClass('-show')
		.toggleAria('aria-hidden');

	$('.footer-social__sublink').changeTabindex();
}

export default new RouteHandler({
	init() {
		$events.on({
			'.js-facebook': {
				click() {
					showFacebookLinks();
				},
				keypress(e, el) {
					if (e.keyCode === 13) {
						showFacebookLinks();
					} else if (e.keyCode === 9) {
						showFacebookLinks();
					}
				},

				blur(e) {
					if ($(e.relatedTarget).eq(0).text() !== 'Homeschool' && $('.footer-social__submenu').hasClass('-show')) {
						showFacebookLinks();
					}
				}
			},
			'.js-facebook-submenu': {
				click(e) {
					e.stopPropagation();
				}
			},

			'.footer-social__sublink': {
				keydown(e, el) {
					if (e.keyCode === 9 && $(el).hasClass('-cs')) {
						showFacebookLinks();
					}
				}
			}
		});
	}
});